import React from "react";
import "./cardMembership.css";
import { useNavigate } from "react-router-dom";
import { CiCircleCheck } from "react-icons/ci";
import IconCircleMembership from "../../assets/icons/iconMembership_Black.svg";
import IconCircleMembershipSelected from "../../assets/icons/iconMembership_Selected.svg";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { fetchNewSessionPayment } from "../../services/rest/membership/membershipService";
import { handleError } from "../../utils/handleError";
import FmdGoodIcon from "@mui/icons-material/FmdGood";

const CardMembership = ({
  membership,
  selected,
  setSelected,
  landing = false,
  setLoading,
}) => {
  const { _id, userType, status } = useSelector((state) => state.userReducer);
  const { isAuthenticated } = useSelector((state) => state.authReducer);
  const navigate = useNavigate();
  const handlePaymentLink = async () => {
    try {
      setLoading(true);
      const response = await fetchNewSessionPayment({
        membershipType: membership?.planName,
        userId: _id,
      });
      response?.url && window.open(response?.url, "_blank");
      setLoading(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(`En este momento no podemos generar su pago. \n ${message}`);
    }
  };
  const handleClick = async () => {
    try {
      if (!isAuthenticated) {
        toast.error(
          "Inicia sesión o crea una cuenta para poder adquirir una membresía."
        );
        return;
      }
      if (status !== "active") {
        toast.error("Complete su cuenta para poder adquirir una membresía.");
        return;
      }
      if (landing) {
        if (userType === "user") {
          console.log("Membresia seleccionada Card Landing", membership);
          setLoading(true);
          await handlePaymentLink();

          navigate("/dashboard/account", {
            state: {
              paymentStatus: true, // Indica si hay link de pago activo
            },
          });
        } else {
          toast.error("Inicia sesión como Runner.");
        }
      } else {
        await handlePaymentLink();
        navigate("/dashboard/account", {
          state: {
            paymentStatus: true, // Indica si hay link de pago activo
          },
        });
      }
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(`En este momento no podemos generar su pago. \n ${message}`);
    }
  };

  return (
    <div
      className="card-membership card  text-white"
      onClick={() => setSelected(membership?._id)}
    >
      <div className="card-body ">
        {selected ? (
          <img src={IconCircleMembershipSelected} alt="Icon" width={30} />
        ) : (
          <img src={IconCircleMembership} alt="Icon" width={30} />
        )}

        <h5 className="card-title text-start">{membership?.planName}</h5>
        <section className="d-flex align-items-center justify-content-start">
          <h2 className="fs-1">${membership?.price} </h2>
          <span className="fw-light"> {membership?.currency} /mes</span>
        </section>

        <Button
          variant="contained"
          className={`btn ${
            selected ? "btn-primary" : "btn-dark"
          } btn-membership me-3 ms-3 mb-2`}
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={() => handleClick()}
        >
          Elegir este plan
        </Button>

        <hr />
        <section className="justify-content-start">
          <p className="text-start">¿Qué incluye?</p>
          <ul className="list-group">
            {membership?.typeUser === "user" && (
              <li className="d-flex justify-content-start align-items-center fw-bold, fs-5 text-primary">
                <FmdGoodIcon className="me-1" />
                Crear {membership?.routeLimit ?? 0} rutas.
              </li>
            )}
            {membership?.description.map((item, index) => {
              return (
                <li
                  className="d-flex justify-content-start align-items-center"
                  key={index}
                >
                  <CiCircleCheck className="me-1" />
                  {item}
                </li>
              );
            })}
          </ul>
        </section>
      </div>
    </div>
  );
};
export default CardMembership;
